export const getApiErrorDescr = ({ code = '', description = '' } = {}) =>
  code === '001' ? 'Please enter a valid city and state or zip code.' :
    description || 'Unknown error occured, please try again'

export const getApiErrorBrands = ({ brands = []} = {}) => brands
